export default __webpack_public_path__ + "static/media/pangong3.21490db4.jpg";